// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__footer__0Gu9G","actions":"Footer-module__actions__CTDNz","cancel":"Footer-module__cancel__qnQkR","confirm":"Footer-module__confirm__b4fGh"};